import { render, staticRenderFns } from "./IpamManagement.vue?vue&type=template&id=81e6c164&scoped=true&"
import script from "./IpamManagement.vue?vue&type=script&lang=js&"
export * from "./IpamManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e6c164",
  null
  
)

export default component.exports